let GiftItem = {
    process: false,
    sending: false,
    loading: false,
    opening: false,
    renderInitForm: (ach_id, creator_gift_name) => {
        let message = `
        ¡Bien <strong>${creator_gift_name}</strong>! ¿Estás listo para enviar este <strong>logro</strong> como un regalo a tu amigo/a especial? Solo quedan unos últimos detalles para que esa persona especial pueda recibir este regalo. Escribe su nombre de usuario <strong style="color:orange">Habtium</strong> y un mensaje que quieras que lea, la persona que reciba el regalo sabrá que tú se lo has enviado, personaliza tu detalle agregando un <strong>mensaje</strong> y eligiendo un envoltorio por unos cuantos <strong>tiums</strong> adicionales y ¡confirma tu pedido! El afro se encargará del resto.
       `;

        return `
        <div class="head">¡Envolviendo el regalo! <span class="glyphicons glyphicons-gift"></span></div>
                <div class="body text">${message}</div>
                <div class="body">
                    <div id="gift_achievement_to" class="gift_creation_container" data-ach="${ach_id}">
                        <div class="form-group">
                            <label>Para:</label>
                            <input type="text" class="form-input" id="username" placeholder="Ingrese el nombre del usuario al que desea realizar el regalo...">
                        </div>
                        <div class="form-group">
                            <label>Mensaje</label>
                            <textarea name="message" id="message" cols="30" rows="3" class="form-input" placeholder="Introduzca un mensaje sobre este regalo... (El usuario podrá visualizar este)" maxlength="200"></textarea>
                        </div>
                        <div>
                            <label>Selecciona un envoltorio</label>
                            <div class="gift-types" class="gift_paper_container">
                                <input type="radio" name="bg_choose" id="bg_choose" value="1" checked="checked" class="mr1-">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_01.png);">
                                    <strong>0</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                </input>
                                <input type="radio" name="bg_choose" id="bg_choose" value="2" class="mr-1">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_02.png);">
                                    <strong>5</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                </input>
                                <input type="radio" name="bg_choose" id="bg_choose" value="3" class="mr-1">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_03.png);">
                                    <strong>5</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                </input>
                                <input type="radio" name="bg_choose" id="bg_choose" value="4" class="mr-1">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_04.png);">
                                    <strong>5</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                <input type="radio" name="bg_choose" id="bg_choose" value="4" class="mr-1">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_05.png);">
                                    <strong>8</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                <input type="radio" name="bg_choose" id="bg_choose" value="4" class="mr-1">
                                <div class="gift_paper_item" style="background: url(https://cdn.habtium.es/habtium/gifts/bg_07.png);">
                                    <strong>8</strong> <span class="glyphicons glyphicons-coins"></span>
                                </div>
                                </input>
                            </div>
                        </div>
                        <div class="gift-options">
                             <button class="button large big green mr-1" onclick="GiftItem.makeGift()">Confirmar regalo</button>
                             <button class="button large big red" onclick="GiftItem.cancel()">Cancelar orden</button>
                        </div>
                    </div>
                </div>
      `;
    },

    cancel: () => {
        document.getElementById("gift_container").innerHTML = "";
    },

    makeGift: () => {
        let username = document.getElementById("username").value;
        let message = document.getElementById("message").value;
        let ach = document
            .getElementById("gift_achievement_to")
            .getAttribute("data-ach");
        let present_type = document.querySelector(
            'input[name="bg_choose"]:checked',
        ).value;

        if (!GiftItem.sending) {
            GiftItem.sending = true;
            Api.post(
                "/store/gift",
                {
                    account_gift: username,
                    gift_message: message,
                    gift_paper: present_type,
                    gift_ach: ach,
                },
                (r) => {
                    if (r.success) {
                        let container =
                            document.getElementById(`gift_container`);
                        container.classList.add("animated", "bounceOutUp");
                        container.innerHTML = "";
                        Alert.push([
                            {
                                type: "success",
                                text: "¡Bien! Hemos enviado tu regalo de forma exitosa.",
                                icon: "circle-check",
                            },
                        ]);
                    } else {
                        switch (r.error.identifier) {
                            case "invalid_or_empty_username":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! El usuario es incorrecto o está vacío.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "username_not_found":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! No hemos encontrado a tu amigo. Prueba a revisar si el usuario está bien escrito.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "auto_gift_is_not_valid":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! Tentador ¿eh? No puedes hacerte un regalo a ti mismo. ¡Lo sentimos!",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "user_already_have_achievement":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! Este usuario ya posee este logro.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "achievement_is_not_longer_available":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! Parece ser que el logro que intentas regalar ya no está disponible.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "free_ach_doesnt_be_a_gift":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! No puedes regalar un logro gratuito.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            case "insufficient_coins":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! No tienes suficientes tiums para poder hacer este regalo.",
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                            default:
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: r.error.identifier,
                                        icon: "circle-alert",
                                    },
                                ]);
                                break;
                        }
                    }
                },
            );
            GiftItem.sending = false;
        }
    },

    init: (id, my_name) => {
        let container = document.getElementById(`gift_container`);
        container.classList.remove("animated", "bounceOutUp");

        if (!GiftItem.process) {
            GiftItem.process = true;
            container.innerHTML = GiftItem.renderInitForm(id, my_name);
            GiftItem.process = false;
        }
    },

    renderNoGifts: () => {
        return `
            <div class="message blue">
                ¡No tienes regalos pendientes por abrir!
            </div>
        `;
    },

    loadingGifts: () => {
        return `
            <div class="message blue">
                Cargando regalos...
            </div>
        `;
    },

    openGift: (gift_id) => {
        if (!GiftItem.opening) {
            let container = document.getElementById(`gift_${gift_id}`);
            GiftItem.opening = true;
            Api.post("/store/open", { gift: gift_id }, (r) => {
                if (r.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: `¡Bien! Se ha sumado a tu cuenta el logro ${r.name}.`,
                            icon: "circle-check",
                        },
                    ]);
                    container.remove();

                    if (r.remaining === "0") {
                        GiftItem.getGifts();
                    }
                } else {
                    switch (r.error.identifier) {
                        case "gift_not_found_or_not_for_you":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Este regalo no te pertenece o ya lo has abierto.",
                                    icon: "circle-alert",
                                },
                            ]);
                            container.remove();
                            break;
                        case "gift_not_found_or_already_opened":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Este regalo ya lo has abierto.",
                                    icon: "circle-alert",
                                },
                            ]);
                            container.remove();
                            break;
                        case "internal_error":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Ha ocurrido un error al abrir este regalo.",
                                    icon: "circle-alert",
                                },
                            ]);
                            break;
                        default:
                            Alert.push([
                                {
                                    type: "danger",
                                    text: r.error.identifier,
                                    icon: "circle-alert",
                                },
                            ]);
                            break;
                    }
                }
            });
            GiftItem.opening = false;
        }
    },

    renderGifts: (data) => {
        let dataHTML = "";

        data.map((gift) => {
            let paperId = gift.paper < 10 ? `0${gift.paper}` : gift.paper;

            dataHTML += `
                <div id="gift_${gift.id}" class="gift_card_container" style="background: url(https://cdn.habtium.com/gifts/bg_${paperId}.png);">
                    <div class="gift_from">
                        <div class="gift_avatar" style="background-image: url(${gift.from.avatar});"></div>
                    </div>
                    <div class="gift-data">
                        <div class="gift_message">
                            <p class="message_text_gift">
                                ${gift.message}
                            </p>
                            <div class="gift_letter_by"><span>Con cariño,</span> <strong>${gift.from.username}</strong></div>
                        </div>
                        <button class="button white big large" onclick="GiftItem.openGift(${gift.id})">¡Abrir regalo ahora!</button>
                    </div>
                </div>
           `;
        });

        return dataHTML;
    },

    getGifts: () => {
        if (!GiftItem.loading) {
            GiftItem.loading = true;
            let container = document.getElementById("gift-container");
            container.innerHTML = GiftItem.loadingGifts();
            Api.get("/store/gift", {}, (r) => {
                if (r.success) {
                    if (r.data.length > 0) {
                        container.innerHTML = GiftItem.renderGifts(r.data);
                    } else {
                        container.innerHTML = GiftItem.renderNoGifts();
                    }
                }
            });
            GiftItem.loading = false;
        }
    },
};
